import { useUpdate } from "ahooks";
import Image from "../../lib/Image";
import { Link } from "react-router-dom";
import general from "../../general";

export default ({
  multiple,
  max,
  files,
  setFiles,
  existImgs,
  setExistImgs,
}) => {
  const update = useUpdate();

  const _setFiles = (files) => {
    setFiles([
      ...files
        .filter((file, index) => {
          return index < max;
        })
        .map((file) => {
          if (file instanceof File) {
            var fr = new FileReader();
            let tmp = { file: file };
            fr.onload = (e) => {
              tmp.url = e.target.result;
              update();
            };
            fr.readAsDataURL(file);
            return tmp;
          } else if (typeof file === "string") {
            return { url: file };
          }
          return file;
        }),
    ]);
  };

  const _setExistImgs = (existImgs) => {
    setExistImgs([
      ...existImgs.filter((file, index) => {
        return index < max;
      }),
    ]);
    setExistImgs(existImgs);
  };

  return (
    <div className="image-picker">
      {existImgs.map((file, index) => (
        <div key={index} className="item item-file">
          <Link
            to={"/img?img=" + index}
            className="img"
            onClick={() => {
              let list = files.map((file) => file.url);
              general.imgs = existImgs.concat(list);
            }}
          >
            <Image src={file} alt="" />
          </Link>

          <img
            className="icon"
            onClick={() =>
              _setExistImgs(existImgs.filter((item) => item !== file))
            }
            src="/resources/four-three/trade/img-close.png"
            alt=""
          />
        </div>
      ))}

      {files.map((file, index) => (
        <div key={index} className="item item-file">
          <Link
            to={"/img?img=" + (existImgs.length + index)}
            className="img"
            onClick={() => {
              let list = files.map((file) => file.url);
              general.imgs = existImgs.concat(list);
            }}
          >
            <Image src={file.url} alt="" />
          </Link>

          <img
            className="icon"
            onClick={() => _setFiles(files.filter((item) => item !== file))}
            src="/resources/four-three/trade/img-close.png"
            alt=""
          />
        </div>
      ))}
      {files.length + existImgs.length < max ? (
        <div className="item item-input">
          <div className="icon">
            <img src="/resources/common/add.png" alt="" />
          </div>
          <input
            type="file"
            multiple={multiple}
            onChange={(e) => _setFiles([...files, ...e.target.files])}
          />
        </div>
      ) : null}
    </div>
  );
};
